import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";
 
const firebaseConfig = {
  apiKey: "AIzaSyCY5qZmfwHN6eO4T1LFTOav2wWKcmgeRQo",
  authDomain: "reyleaf-4b6ba.firebaseapp.com",
  projectId: "reyleaf-4b6ba",
  storageBucket: "reyleaf-4b6ba.firebasestorage.app",
  messagingSenderId: "1077260570222",
  appId: "1:1077260570222:web:6dcdbc4dca72b48723e07f",
  measurementId: "G-TZ0K5N8F9B"
};
 
export const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app)


